export abstract class ArrayHelper {

    static numberComperator(a: number, b: number) {
        return a === b ? 0 : (a > b ? 1 : -1);
    }

    /**
     * Returns true if the array is null or contains no elements
     *
     * @param {Array<any>} arr
     * @returns {boolean}
     * @memberof ArrayHelper
     */
    static isNullOrEmpty(arr: Array<any>): boolean {
        return arr === null || arr.length === 0;
    }

    /**
     * Returns true if the array is not null and contains elements
     *
     * @param {Array<any>} arr
     * @returns {boolean}
     * @memberof ArrayHelper
     */
    static hasAny(arr: Array<any>): boolean {
        return !ArrayHelper.isNullOrEmpty(arr);
    }

    /**
     * Returns true if the array is not null and contains the given value
     *
     * @static
     * @template T
     * @param {Array<T>} arr
     * @param {T} value
     * @returns {boolean}
     * @memberof ArrayHelper
     */
    static contains<T>(arr: Array<T>, value: T): boolean {
        return arr !== null && arr.length > 0 && arr.indexOf(value) > -1;
    }

}
